var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m29 56.7h454c12.6 0 23 10.4 23 23v261c0 12.6-10.4 23-23 23h-454c-12.6 0-23-10.4-23-23v-261c0-12.6 10.4-23 23-23z",
    fill: "#24a0f4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m80.8 114h111.5c3.5 0 6.7 1.4 9.1 3.8 2.3 2.3 3.7 5.5 3.7 9v64.1c0 3.5-1.4 6.7-3.7 9.1-2.3 2.3-5.5 3.7-9.1 3.7h-111.5c-3.5 0-6.7-1.4-9-3.8-2.3-2.3-3.7-5.5-3.7-9.1v-64.1c0-3.5 1.4-6.7 3.7-9 2.3-2.3 5.5-3.7 9-3.7z",
    fill: "#f6cd35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28.6 340.7v-261c0-12.6 10.3-23 23-23h-22.6c-12.6 0-23 10.4-23 23v261c0 12.6 10.4 23 23 23h22.6c-12.7 0-23-10.3-23-23z",
    fill: "#1691e3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m460.3 248.5-116.1 115.2-59.9-59.4-45.7 46 105.4 105 .2-.2c53.9-53.5 107.9-107 161.8-160.5z",
    fill: "#f6cd35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m460.3 248.5 23 23-115.7 115.7-23 23.1-23-23.1-59.9-59.8 22.6-23 59.9 59.3z",
    fill: "#faaa2a"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.6 109.8c-7.8 0-14.2 6.4-14.2 14.2v71.4c0 7.9 6.4 14.3 14.2 14.3h124.3c7.8 0 14.2-6.4 14.2-14.3v-71.4c0-7.8-6.4-14.2-14.2-14.2zm122.6 84.1h-121v-68.1h121zm313.3-112.5v177.4c0 4.4-3.6 7.9-7.9 7.9-4.4 0-7.9-3.6-7.9-7.9v-177.4c0-8.2-6.6-14.8-14.8-14.8h-449.7c-8.2 0-14.8 6.7-14.8 14.8v258.5c0 8.2 6.6 14.8 14.8 14.8h185.7c4.4 0 7.9 3.6 7.9 7.9s-3.6 7.9-7.9 7.9h-185.7c-16.9 0-30.7-13.8-30.7-30.7v-258.4c0-16.9 13.8-30.7 30.7-30.7h449.6c16.9 0 30.7 13.8 30.7 30.7zm-47.5 161.6c-1.5-1.5-3.5-2.3-5.6-2.4-2.1 0-4.1.8-5.6 2.3l-109.5 108.6-53.7-53.2c-3.1-3.1-8.1-3.1-11.2 0l-45.2 45.6c-3.1 3.1-3.1 8.1 0 11.2l104.3 103.9c1.6 1.5 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l.2-.2c26.5-26.3 52.9-52.5 79.4-78.8 26.9-26.7 53.9-53.5 80.8-80.2 3.1-3.1 3.1-8.1 0-11.2zm-46.8 125.7c-24.7 24.5-49.4 49-74 73.5l-93-92.7 34-34.3 53.6 53.2c3.1 3.1 8.1 3.1 11.2 0l109.4-108.5 34 34.3c-25.1 24.7-50.2 49.6-75.2 74.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaid);
export default __webpack_public_path__ + "static/media/paid.74037b7773c09a4a3af432628a7e7419.svg";
export { ForwardRef as ReactComponent };